import React, { useState, useEffect } from 'react';
import { mockData } from '../mock';
import Hero from './sections/Hero';
import About from './sections/About';
import Skills from './sections/Skills';
import Projects from './sections/Projects';
import Experience from './sections/Experience';
import Contact from './sections/Contact';
import Navigation from './Navigation';
import Footer from './Footer';

const Portfolio = () => {
  const [projects, setProjects] = useState([]);
  const [experience, setExperience] = useState([]);
  const [skills, setSkills] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Простая загрузка данных без localStorage
    setProjects(mockData.projects);
    setExperience(mockData.experience);
    setSkills(mockData.skills);
    setLoading(false);
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen bg-white flex items-center justify-center">
        <div className="text-center">
          <div className="w-8 h-8 border-2 border-gray-300 border-t-gray-800 rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-gray-600 text-lg">Loading portfolio...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-white">
      <Navigation />
      <main>
        <Hero personal={mockData.personal} />
        <About 
          personal={mockData.personal} 
          education={mockData.education} 
          certifications={mockData.certifications} 
        />
        <Skills skills={skills} />
        <Projects projects={projects} />
        <Experience experience={experience} />
        <Contact personal={mockData.personal} />
      </main>
      <Footer personal={mockData.personal} />
    </div>
  );
};

export default Portfolio;